// extracted by mini-css-extract-plugin
module.exports = {"icon":"MediaIcon_icon__Wa5bu","rounded":"MediaIcon_rounded__ivRas"};